import { ActionReducerMap } from '@ngrx/store';
import { companyReducer } from './states/company/company.reducer';
import { CompanyState } from './states/company/company.types';
import { ConfigEffects } from './states/config/config.effects';
import { configReducer } from './states/config/config.reducer';
import { ConfigState } from './states/config/config.types';
import { PaymentEffects } from './states/payment/payment.effects';
import { PaymentState } from './states/payment/payment.types';
import { PurchaseEffects } from './states/purchase/purchase.effects';
import { purchaseReducer } from './states/purchase/purchase.reducer';
import { PurchaseState } from './states/purchase/purchase.types';
import { paymentReducer } from './states/payment/payment.reducer';
import { MicroCreditState } from './states/micro-credit/micro-credit.types';
import { SessionState } from './states/session/session.types';
import { sessionReducer } from './states/session/session.reducer';

export interface AppState {
  config: ConfigState;
  company: CompanyState;
  purchase: PurchaseState;
  payment: PaymentState;
  microCredit?: MicroCreditState;
  session: SessionState;
}
export const Reducers: ActionReducerMap<AppState> = {
  config: configReducer,
  company: companyReducer,
  purchase: purchaseReducer,
  payment: paymentReducer,
  session: sessionReducer,
};

export const Effects = [ConfigEffects, PurchaseEffects, PaymentEffects];
